import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import swal from 'sweetalert';

// imort modules
// import session from './module/_session';
import activity from './module/activity';
import gradeActivity from './module/grade-activity';
import subjectActivity from './module/subject-activity';
import clusterActivity from './module/cluster-activity';
import lessonActivity from './module/lesson-activity';
import serveLesson from './module/serve-lesson';
import subject from './module/subject';
import cluster from './module/cluster';
import lesson from './module/lesson';
import permission from './module/permission';
import auth from './module/auth';
import app from './module/app';
import tagsView from './module/tags-view';

import clownToWater from './module/practices/clownToWater';
import easterEgg from './module/practices/easterEgg';
import expandedForm from './module/practices/expandedForm';
import fishyProblems from './module/practices/fishyProblems';
import petLife from './module/practices/petLife';
import pumpkinClock from './module/practices/pumpkinClock';
import settings from './module/practices/settings';
import savingMoney from './module/practices/savingMoney';
import soccerGoal from './module/practices/soccerGoal';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    // session,
    activity,
    gradeActivity,
    subjectActivity,
    clusterActivity,
    lessonActivity,
    serveLesson,
    subject,
    cluster,
    lesson,
    auth,
    permission,
    app,
    tagsView,
    clownToWater,
    easterEgg,
    expandedForm,
    fishyProblems,
    petLife,
    pumpkinClock,
    settings,
    savingMoney,
    soccerGoal,
  },
  state: {
    selectedLessonId: null,
    // Alamcena el tiempo de actividad del usuario logeado en la app
    userActivityTime: {
      start_time: '',
      end_time: '',
      activity_timer: 0,
      student_id: 0,
      tutor_id: 0,
      tutor_name: '',
    },
    // Se determina si se hace uso del crtonometro
    activatedChronometer: false,
    /** Almacena la información del usuario autenticado */
    userAuthenticated: {
      avatar: '',
    },
    /** Determina si TPM esta activado */
    activationStatus: false,
    /** Determina el estado para mostrar el boton back del navbar */
    showBtnBack: false,
    /** Determina el estado para mostrar el idioma seleccionado */
    language: 'en',
    /** Determina el estado de una solicitud al servidor */
    processing: false,
    /** Determina el estado de una solicitud al servidor cuando se realiza una busqueda de lessons */
    searchProcessing: false,
    /** Objecto donde se almacena todo lo relacionado a la section tutor */
    sectionOfStoreOfTutor: {
      // account/Signup forma el tipo de formulario dependiendo el valor que tenga signupRol (student or tutor).
      typeOfSignUp: '',
      /** Determina si muestra el modal para registro de un nuevo estudiante */
      showModalSignUp: false,
      listOfTutors: [],
      listOfStudents: [],
    },
    modalTools: {
      searchModal: false,
      glossaryModal: false,
    },
    main: {
      style: '',
    },
    isStudent: false,
    isTutor: false,
    intro: true,
    introShown: false,
    lessonAudio: true,
    sidebar: false,
    sidebarItems: [
      { item: 'Home', active: false },
      { item: 'Search', active: false },
      { item: 'Glossary', active: false },
      { item: 'Books', active: false },
      { item: 'Change User', active: false },
    ],
    showComponentsEvaluation: {
      previousResults: false,
      fullResults: false,
    },
    breadCrumb: '/home',
    breadCrumb_name: '',
    titleNow: 'title',
    gradeData: '',
    grade: {},
    currentSubject: {},
    currentCluster: {
      last: false,
      current: {},
      next: {},
    },
    currentLesson: {},
    showProgress: true,
    variable: 0,
    clusterData: {},
    routeContructor: '',
    slideState: '',
    progressData: '',
    serverURL: 'ws://70.35.203.32:3003',
    cookie: '',
    questForTest: 10,
    questForPrestest: 4,
    // Styles
    style: {
      modal: {
        width: '',
        prefixWidth: '',
        height: '',
        prefixHeight: '',
      },
    },
    // Almacena todo el contenido del modelo nivel
    nivel: [],
    // Almacena todos los test almacenados en la base de datos
    testsFromDB: [],
    // Guarda las lessons relizadas por el estudiante
    lessonsLearned: [],
    showUpdateNotification: false,
    categories: [],
    currentGrade: {},
    currentLevel:0,
  },
  getters: {
    currentGrade: state => state.currentGrade,
    selectedLessonId: state => state.selectedLessonId,
    getCategories: state => state.categories,
    lessonsLearned: state => state.lessonsLearned,
    nivel: state => state.nivel,
    userActivityTime: state => state.userActivityTime,
    statusActivation: state => state.activationStatus,
    activatedChronometer: state => state.activatedChronometer,
    btnBackNavbar: state => state.showBtnBack,
    language: state => state.language,
    userAuthenticated: state => {
      return state.userAuthenticated;
    },
    getAvatarOfUserAuthenticated: state => {
      return state.userAuthenticated.avatar;
    },
    getProgressOfTheCurrentGrade: state => {
      var percent = 0;
      var subjectsNumber = 0;
      for (var subject in state.currentGrade) {
        percent += parseFloat(state.currentGrade[subject].progress_percent);
        subjectsNumber = subject;
      }
      subjectsNumber = parseInt(subjectsNumber) + 1;
      return percent / subjectsNumber;
    },
    processing: state => {
      return state.processing;
    },
    searchProcessing: state => {
      return state.searchProcessing;
    },
    getAllStudents: state => {
      return state.sectionOfStoreOfTutor.listOfStudents;
    },
    getBreadCrumb: state => {
      return state.breadCrumb;
    },
    getBreadCrumbName: state => {
      return state.breadCrumb_name;
    },
    getCurrentLevel: state => state.currentLevel
  },
  mutations: {
    SET_CURRENT_GRADE: (state, grade) => {
      state.currentGrade = { ...grade };
    },
    SET_SELECTED_LESSON_ID(state, value) {
      state.selectedLessonId = value;
    },
    SET_DATA_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    ADD_LESSON_TO_LESSONSLEARNED(state, lesson) {
      state.lessonsLearned.push(lesson);
      console.log(state.lessonsLearned);
    },
    // Set hora de inicio
    SET_STARTTIME_IN_USERACTIVITYTIME(state, payload) {
      state.userActivityTime.start_time = payload;
    },
    // Set hora de finalización
    SET_ENDTIME_IN_USERACTIVITYTIME(state, payload) {
      state.userActivityTime.end_time = payload;
    },
    // Registra el id del estudiante
    SET_STUDENTID_IN_USERACTIVITYTIME(state, payload) {
      state.userActivityTime.student_id = payload;
    },
    // Registra el id del tutor
    SET_TUTORID_IN_USERACTIVITYTIME(state, payload) {
      state.userActivityTime.tutor_id = payload;
    },
    // Inicia o renuda el tiempo de interacción con la app
    PLAY_ACTIVITY_TIMER(state) {
      state.userActivityTime.activity_timer++;
    },
    // Resesea el modelo userActivityTime
    CLEAR_USERACTIVITYTIME(state) {
      state.userActivityTime = {
        start_time: '',
        end_time: '',
        activity_timer: 0,
        student_id: 0,
        tutor_id: 0,
      };
    },
    // Cambia el stado de activatedChronometer a true o false
    SET_CHRONOMETER_STATUS(state, payload) {
      state.activatedChronometer = payload;
    },
    SHOW_UPDATE_NOTIFICATION(state) {
      state.showUpdateNotification = true;
    },
    HIDE_UPDATE_NOTIFICATION(state) {
      state.showUpdateNotification = false;
    },
    // Recibe un valor booleano para determinar el stado de activación de TPM
    setActivationStatus(state, payload) {
      state.activationStatus = payload;
    },
    // Actualiza showBtnBack para mostrar el boton
    showBtnBackNavbar(state, val) {
      state.showBtnBack = val;
    },
    // Actualiza showBtnBack para ocultar el boton
    hiddenBtnBackNavbar(state, val) {
      state.showBtnBack = val;
    },
    // Actualiza el tipo de lenguaje seleccionado
    setLanguage(state, lang) {
      state.language = lang;
    },
    // Actualiza el nombre de un usuario especifico en el array state.sectionOfStoreOfTutor.listOfStudents[]
    UPDATE_FULLNAME_USER_IN_LISTOFSTUDENTS(state, payload) {
      state.sectionOfStoreOfTutor.listOfStudents.forEach((student, index) => {
        if (student.id === parseInt(payload.id)) {
          state.sectionOfStoreOfTutor.listOfStudents[index].firstname = payload.firstname;
          state.sectionOfStoreOfTutor.listOfStudents[index].lastname = payload.lastname;
        }
      });
    },
    UPDATE_AVATAR_OF_USER_AUTHENTICATED(state, payload) {
      state.userAuthenticated.avatar = payload;
    },
    UPDATE_NAME_OF_USER_AUTHENTICATED(state, payload) {
      state.userAuthenticated.firstname = payload.firstname;
      state.userAuthenticated.lastname = payload.lastname;
    },
    UPDATE_NAME_SCHOOL_OF_USER_AUTHENTICATED(state, payload) {
      state.userAuthenticated.name_of_the_school = payload;
    },
    UPDATE_GRADEID_OF_USER_AUTHENTICATED(state, payload) {
      state.userAuthenticated.grade_id = payload;
    },
    SET_NEW_STUDENT(state, payload) {
      if (!state.sectionOfStoreOfTutor.listOfStudents) {
        state.sectionOfStoreOfTutor.listOfStudents = [];
      }
      state.sectionOfStoreOfTutor.listOfStudents.push(payload);
    },
    SET_NEW_TUTOR(state, payload) {
      state.sectionOfStoreOfTutor.listOfTutors.push(payload);
    },
    START_PROCESSING(state) {
      state.processing = true;
    },
    STOP_PROCESSING(state) {
      state.processing = false;
    },
    START_SEARCHPROCESSING(state) {
      state.searchProcessing = true;
    },
    STOP_SEARCHPROCESSING(state) {
      state.searchProcessing = false;
    },
    SET_COOKIE(state, payload) {
      localStorage.setItem('access_token', payload);
      state.cookie = payload;
    },
    SET_QUESTION_PER_TEST(state, payload) {
      state.questForTest = payload;
    },
    SECTION_TUTOR_TYPEOFSIGNUP(state, payload) {
      state.sectionOfStoreOfTutor.typeOfSignUp = payload;
    },
    SHOW_OR_HIDDEN_MODAL_REGISTER_NEW_STUDENT(state, payload) {
      state.sectionOfStoreOfTutor.showModalSignUp = payload;
    },
    SHOW_OR_HIDDEN_FULLRESULTS_COMPONENT_EVALUATION(state, payload) {
      state.showComponentsEvaluation.fullResults = payload;
    },
    SHOW_OR_HIDDEN_PREVIOUSRESULTS_COMPONENT_EVALUATION(state, payload) {
      state.showComponentsEvaluation.previousResults = payload;
    },
    SHOW_PROGRESS_BAR(state, payload) {
      state.showProgress = payload;
    },
    SET_STYLE_MODAL(state, payload) {
      state.style.modal = payload;
    },
    SIDEBAR_ACTIVE_CLASS(state, payload) {
      if (payload.item === 'Glossary') {
        state.sidebarItems[2].active = payload.active;
      } else if (payload.item === 'Search') {
        state.sidebarItems[1].active = payload.active;
      } else if (payload.item === 'Books') {
        state.sidebarItems[3].active = payload.active;
      } else if (payload.item === 'Home') {
        state.sidebarItems[0].active = payload.active;
      }
    },
    // Crea un modelo donde guarda toda configuración que tenga que ver con la evaluación de un estudiante
    SAVE_SETTINGS_EVALUATION(state, payload) {
      Vue.set(state, 'evaluation', payload);
    },
    SET_SUBJECTID_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'subjectIdSelected', payload);
    },
    SET_SUBJECTNAME_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'subjectNameSelected', payload);
    },
    SET_STUDENTNAME_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'studentNameSelected', payload);
    },
    SET_STUDENTID_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'studentIDSelected', payload);
    },
    SET_TYPE_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'typeEvaluation', payload);
    },
    SET_GRADEID_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'gradeIdSelected', payload);
    },
    SET_GRADEPATH_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'gradePathSelected', payload);
    },
    SET_GRADENAME_SELECTED_EVALUATION(state, payload) {
      Vue.set(state.evaluation, 'gradeNameSelected', payload);
    },
    /** Almacena un array de las materias que se usaron para la evaluación */
    SET_DETAILS_EVALUATION_RESULTS(state, payload) {
      Vue.set(state.evaluation, 'resultOfEvaluation', payload);
    },
    OPEN_SEARCH_MODAL(state, payload) {
      state.modalTools.searchModal = payload;
    },
    OPEN_GLOSSARY_MODAL(state, payload) {
      state.modalTools.glossaryModal = payload;
    },
    IS_STUDENT(state, payload) {
      state.isStudent = payload;
    },
    IS_TUTOR(state, payload) {
      state.isTutor = payload;
    },
    SET_DATA_OF_THE_USER_AUTHENTICATED(state, payload) {
      state.userAuthenticated = payload;
      // Vue.set(state, 'userAuthenticated', payload)
    },
    // this.$store.state.style.modal.width = '95'
    modelWidth(state, payload) {
      state.style.modal.width = payload;
    },
    // this.$store.state.style.modal.prefixWidth = '%'
    modelPrefixWidth(state, payload) {
      state.style.modal.prefixWidth = payload;
    },
    // this.$store.state.style.modal.height = '93'
    modelHeigth(state, payload) {
      state.style.modal.height = payload;
    },
    // this.$store.state.style.modal.prefixHeight = 'vh'
    modelPrefixHeight(state, payload) {
      state.style.modal.prefixHeight = payload;
    },
    RESULT_TEST(state, payload) {
      Vue.set(state, 'testModel', payload);
    },
    showSidebar(state, payload) {
      state.sidebar = payload;
    },
    showIntro(state, payload) {
      state.intro = payload;
    },
    setShownIntro(state, payload) {
      state.introShown = payload;
    },
    playLessonAudio(state, payload) {
      state.lessonAudio = payload;
    },
    lessonData(state, payload) {
      state.gradeData = payload;
    },
    clustersData(state, payload) {
      state.clusterData = payload;
    },
    isLesson(state, payload) {
      state.isLesson = payload;
    },
    routeContructor(state, payload) {
      state.routeContructor = payload;
    },
    updateBreadCrumb(state, preload) {
      state.breadCrumb = preload.url;
      state.breadCrumb_name = preload.name;
    },
    slideState(state, payload) {
      state.slideState = payload;
    },
    progressData(state, payload) {
      state.progressData = payload;
    },
    SET_GRADE_DATA(state, payload) {
      Vue.set(state, 'currentGrade', payload);
    },
    // Obtiene los grados como argumento y los almacena en store
    SET_ALL_GRADES(state, payload) {
      Vue.set(state, 'allGrades', payload);
    },
    CURRENT_GRADE_TOTAL_LESSONS(state, payload) {
      state.currentGrade[payload.index].total_lessons += payload.data;
    },
    CURRENT_CLUSTER_LAST(state, payload) {
      if (!payload) {
        payload = false;
      }
      state.currentCluster.last = payload;
      // Vue.set(state.currentCluster, 'last', payload)
    },
    CURRENT_CLUSTER_CURRENT(state, payload) {
      if (!payload) {
        payload = false;
      }
      // if (payload) {
      // Vue.prototype.$activity.$emit('create-cluster-activity', payload.id)
      // }
      state.currentCluster.current = payload;
      // Vue.set(state.currentCluster, 'current', payload)
    },
    CURRENT_CLUSTER_NEXT(state, payload) {
      if (!payload) {
        payload = false;
      }
      state.currentCluster.next = payload;
      // Vue.set(state.currentCluster, 'next', payload)
    },
    CURRENT_CLUSTER_TOTAL_LESSONS(state, payload) {
      state.currentGrade[payload.indexSubject].cluster[payload.indexCluster].total_lessons = payload.data;
      // Vue.set(state.currentGrade[payload.indexSubject].cluster[payload.indexCluster], 'total_lessons', payload.data)
    },
    CURRENT_SUBJECT_CURRENT(state, payload) {
      if (!payload) {
        payload = false;
      }
      Vue.set(state.currentSubject, 'current', payload);
    },
    CURRENT_SUBJECT_LAST(state, payload) {
      if (!payload) {
        payload = false;
      }
      Vue.set(state.currentSubject, 'last', payload);
    },
    CURRENT_SUBJECT_NEXT(state, payload) {
      if (!payload) {
        payload = false;
      }
      Vue.set(state.currentSubject, 'next', payload);
    },
    CURRENT_LESSON_LAST(state, payload) {
      if (!payload) {
        payload = false;
      }
      // state.currentLesson.last = payload
      Vue.set(state.currentLesson, 'last', payload);
    },
    CURRENT_LESSON_CURRENT(state, payload) {
      if (!payload) {
        payload = false;
      }
      Vue.set(state.currentLesson, 'current', payload);
    },
    CURRENT_LESSON_NEXT(state, payload) {
      if (!payload) {
        payload = false;
      }
      Vue.set(state.currentLesson, 'next', payload);
    },
    /** NO NECESARIO - REFACTORIZAR */
    SET_PERCENT_PROGRESS_BY_CLUSTER(state, payload) {
      state.currentGrade[payload.subjectIndex].cluster[payload.clusterIndex].progress_percent = payload.data;
    },
    /** Setea el progreso en porcentaje por materia */
    SET_PERCENT_PROGRESS_BY_SUBJECT(state, payload) {
      state.currentGrade[payload.subjectIndex].progress_percent = payload.data;
    },
    GET_SETTINGS_DATA(state, payload) {
      Vue.set(state, 'settings', payload);
    },
    UNLOCK_NEXT_LESSON(state, payload) {
      state.currentLesson.next.is_locked = payload;
    },
    UNLOCK_CLUSTER(state, payload) {
      state.currentSubject.current.cluster[payload.index].is_locked = payload.value;
    },
    SET_CURRENT_LEVEL(state, value) {
      state.currentLevel = value;
    },
  },
  actions: {
    getActivationStatus: ({ commit }) => {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`tpm_is_activated`)
          .then(res => {
            commit('setActivationStatus', res.data);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    changeLanguage: ({ commit }, lang) => {
      commit('setLanguage', lang);
    },
    setShowIntro: ({ commit }, show) => {
      commit('showIntro', show);
    },
    haveShownIntro: ({ commit }, shown) => {
      commit('setShownIntro', shown);
    },
    setLessonAudio: ({ commit }, play) => {
      commit('playLessonAudio', play);
    },
    updateBreadCrumb: ({ commit }, payload) => {
      commit('updateBreadCrumb', payload);
    },
    changeAvatarOfUserAuthenticated: ({ commit }, payload) => {
      // console.log(payload)
      commit('UPDATE_AVATAR_OF_USER_AUTHENTICATED', payload);
    },
    // Obtiene la información de la API
    getGradeData({ commit, state }, payload) {
      commit('START_PROCESSING');
      if (!payload.grade) {
        payload.grade = false;
      }
      if (!payload.subject) {
        payload.subject = false;
      }
      if (!payload.cluster) {
        payload.lesson = false;
      }
      if (!payload.lesson) {
        payload.lesson = false;
      }
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`progress_view`, {
            grade_path: payload.grade,
            token: state.cookie,
            lang: state.language,
          })
          .then(e => {
            commit('SET_GRADE_DATA', e.data);
            commit('STOP_PROCESSING');
            resolve(e.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /** Obtiene el progreso del grado actual - Grado seleccionado */
    getProgressOfTheSelectedGrade({ commit, state }) {
      for (var subject in state.currentGrade) {
        for (var cluster in state.currentGrade[subject].cluster) {
          // Total de lessons del grado actual
          commit('CURRENT_GRADE_TOTAL_LESSONS', {
            index: subject,
            data: state.currentGrade[subject].cluster[cluster].lessons.length,
          });
          // Total de lessons por cluster
          commit('CURRENT_CLUSTER_TOTAL_LESSONS', {
            indexSubject: subject,
            indexCluster: cluster,
            data: state.currentGrade[subject].cluster[cluster].lessons.length,
          });
          for (var lesson in state.currentGrade[subject].cluster[cluster].lessons) {
            // Determina el progreso del grado dependiendo del status de lessons 'state.id'
            if (state.currentGrade[subject].cluster[cluster].lessons[lesson].state_id === 1) {
              state.currentGrade[subject].cluster[cluster].not_started += 1;
              state.currentGrade[subject].not_started += 1;
            } else if (state.currentGrade[subject].cluster[cluster].lessons[lesson].state_id === 2) {
              state.currentGrade[subject].cluster[cluster].in_progress += 1;
              state.currentGrade[subject].in_progress += 1;
            } else if (state.currentGrade[subject].cluster[cluster].lessons[lesson].state_id === 3) {
              state.currentGrade[subject].cluster[cluster].completed_lessons += 1;
              state.currentGrade[subject].completed_lessons += 1;
            }
          }
          // Se calcula el porcentaje del progreso del alumno por cluster
          var percentCluster;
          if (state.currentGrade[subject].cluster[cluster].is_locked === 2) {
            percentCluster = 100;
          } else {
            percentCluster =
              (state.currentGrade[subject].cluster[cluster].completed_lessons * 80) /
              state.currentGrade[subject].cluster[cluster].total_lessons;
          }
          commit('SET_PERCENT_PROGRESS_BY_CLUSTER', {
            subjectIndex: subject,
            clusterIndex: cluster,
            data: percentCluster,
          });
        }
        // Calcula el porcentaje del progreso del alumno por materia
        var percentSubject =
          (state.currentGrade[subject].completed_lessons * 100) / state.currentGrade[subject].total_lessons;
        commit('SET_PERCENT_PROGRESS_BY_SUBJECT', {
          subjectIndex: subject,
          data: percentSubject.toFixed(1),
        });
      }
    },
    /** Obtiene la materia actual, anterior y la que sigue del grado actual */
    getSubjectsOfTheGradeSelected({ commit, state }, payload) {
      for (var subject in state.currentGrade) {
        if (state.currentGrade[subject].path === payload.subject) {
          commit('CURRENT_SUBJECT_CURRENT', state.currentGrade[parseInt(subject)]);
          commit('CURRENT_SUBJECT_LAST', state.currentGrade[parseInt(subject) - 1]);
          commit('CURRENT_SUBJECT_NEXT', state.currentGrade[parseInt(subject) + 1]);
        }
        for (var cluster in state.currentGrade[subject].cluster) {
          if (state.currentGrade[subject].cluster[cluster].path === payload.cluster) {
            commit('CURRENT_CLUSTER_LAST', state.currentGrade[subject].cluster[parseInt(cluster) - 1]);
            commit('CURRENT_CLUSTER_CURRENT', state.currentGrade[subject].cluster[parseInt(cluster)]);
            commit('CURRENT_CLUSTER_NEXT', state.currentGrade[subject].cluster[parseInt(cluster) + 1]);
            // console.log('state.currentLesson.current')
            // console.log(state.currentLesson.current)
            // console.log('state.currentLesson.current')
          }
        }
      }
    },
    /** Obtiene el cluster actual, anterior y la que sigue del grado actual */
    getClusterOfTheGradeSelected({ commit, state }, payload) {
      for (var subject in state.currentGrade) {
        for (var cluster in state.currentGrade[subject].cluster) {
          if (state.currentGrade[subject].cluster[cluster].path === payload.cluster) {
            if (payload.unlockCluster) {
              // Debloquea cluster
              commit('UNLOCK_CLUSTER', { index: parseInt(cluster), value: 1 });
            }
            // Se hace uso de la siguiente variable para hacer conparaciones con la longitud del array de lessons
            if (parseInt(cluster) - 1 >= 0) {
              commit('CURRENT_CLUSTER_LAST', state.currentGrade[subject].cluster[parseInt(cluster) - 1]);
            } else {
              commit('CURRENT_CLUSTER_LAST', false);
            }
            commit('CURRENT_CLUSTER_CURRENT', state.currentGrade[subject].cluster[parseInt(cluster)]);
            commit('CURRENT_CLUSTER_NEXT', state.currentGrade[subject].cluster[parseInt(cluster) + 1]);
          }
        }
      }
    },
    /** Obtiene las lessons actual, anterior y la que sigue del grado actual */
    getLessonOfTheGradeSelected({ commit, state }, payload) {
      commit('START_PROCESSING');
      return new Promise(resolve => {
        for (var subject in state.currentGrade) {
          for (var cluster in state.currentGrade[subject].cluster) {
            for (var lesson in state.currentGrade[subject].cluster[cluster].lessons) {
              if (state.currentGrade[subject].cluster[cluster].lessons[lesson].path === payload.lesson) {
                // Se obtiene la dimensión del array de  lessons
                var lessonsLength = _.size(state.currentGrade[subject].cluster[cluster].lessons);
                // Se hace uso de la siguiente variable para hacer conparaciones con la longitud del array de lessons
                var index = parseInt(lesson) + 1;
                commit(
                  'CURRENT_LESSON_LAST',
                  state.currentGrade[subject].cluster[cluster].lessons[parseInt(lesson) - 1],
                );
                commit('CURRENT_LESSON_CURRENT', state.currentGrade[subject].cluster[cluster].lessons[lesson]);
                if (lessonsLength !== index) {
                  commit(
                    'CURRENT_LESSON_NEXT',
                    state.currentGrade[subject].cluster[cluster].lessons[parseInt(lesson) + 1],
                  );
                } else {
                  commit('CURRENT_LESSON_NEXT', {});
                }
              }
            }
          }
        }
        resolve();
        commit('STOP_PROCESSING');
      });
    },
    /** Guarda el progreso de la lesson seleccionada, dentro del grado alamacenado en store.currentGrade */
    saveProgressInLessonSelected({ state }, payload) {
      for (var subject in state.currentGrade) {
        for (var cluster in state.currentGrade[subject].cluster) {
          for (var lesson in state.currentGrade[subject].cluster[cluster].lessons) {
            if (state.currentGrade[subject].cluster[cluster].lessons[lesson].path === payload.lesson) {
              if (
                payload.state_id === 3 &&
                state.currentGrade[subject].cluster[cluster].lessons[lesson].state_id !== 3
              ) {
                // Se suma uno por la lesson terminada
                state.currentGrade[subject].cluster[cluster].completed_lessons += 1;
                // Calcula el porcentaje del progreso del alumno por cluster
                var percentCluster =
                  (state.currentGrade[subject].cluster[cluster].completed_lessons * 80) /
                  state.currentGrade[subject].cluster[cluster].total_lessons;
                if (percentCluster <= 80) {
                  state.currentGrade[subject].cluster[cluster].progress_percent = percentCluster;
                  // Se suma uno por la lesson terminada
                  state.currentGrade[subject].completed_lessons += 1;
                  // Calcula el porcentaje del progreso del alumno por materia
                  var percent =
                    (state.currentGrade[subject].completed_lessons * 100) / state.currentGrade[subject].total_lessons;
                  state.currentGrade[subject].progress_percent = percent.toFixed(1);
                }
              }
              state.currentGrade[subject].cluster[cluster].lessons[lesson].state_id = payload.state_id;
            }
          }
        }
      }
    },
    /** Hace una solicitud al server para obtener las configuraciones hecha por el tutor, de la base de datos */
    settingsFromDB({ commit, state }) {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`get_settings_tests`, {
            data: '',
            token: state.cookie,
          })
          .then(res => {
            commit('GET_SETTINGS_DATA', res.data);
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getAllGradesFromDB({ commit, state }) {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`get_id_name_path_all_grade`, {
            token: state.cookie,
          })
          .then(e => {
            resolve(e.data);
            commit('SET_ALL_GRADES', e.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getDataOfTheUserAuthenticated({ commit, state }) {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`get-user`, {
            data: '',
            token: state.cookie,
          })
          .then(res => {
            commit('IS_STUDENT', res.data.rol_id === 1);
            commit('IS_TUTOR', res.data.rol_id === 2);
            commit('SET_DATA_OF_THE_USER_AUTHENTICATED', res.data);
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // Desencripta la lesson actual
    decryptLesson({ commit, state }, payload) {
      commit('START_PROCESSING');
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`api/decrypt_lesson`, {
            path: payload.local_path,
            token: state.cookie,
            status: false,
          })
          .then(res => {
            commit('STOP_PROCESSING');
            resolve(res);
          })
          .catch(error => {
            commit('STOP_PROCESSING');
            swal(
              'Upss',
              state.language === 'en'
                ? 'Please request the content of ' + state.currentSubject.current.nombre
                : 'Por favor solicita el contenido de ' + state.currentSubject.current.nombre,
              'warning',
            );
            reject(error);
          });
      });
    },
    // Encripta la lesson actual una vez que haya sido consumida
    encryptLesson({ commit, state }, payload) {
      commit('START_PROCESSING');
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`api/encrypt_lesson`, {
            path: payload.local_path,
            token: state.cookie,
            status: false,
          })
          .then(res => {
            commit('STOP_PROCESSING');
            resolve(res);
          })
          .catch(error => {
            commit('STOP_PROCESSING');
            reject(error);
          });
      });
    },
    // Guarda la el tiempo de actividad y detalles del estudiante logeado
    saveUserActivityTime({ state }) {
      state.userActivityTime.token = state.cookie;
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`api/save_user_activity_time`, state.userActivityTime)
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllContentFromNivel({ state }) {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .post(`api/get_all_content_from_nivel`, {
            lang: state.language,
          })
          .then(res => {
            // console.log(res.data)
            state.nivel = res.data;
            resolve(res);
          })
          .catch(error => {
            reject(error);
            console.log(error);
          });
      });
    },
    getAllTestFromDB({ state }) {
      return new Promise(function (resolve, reject) {
        Vue.prototype.$httpMain
          .get(`tests`)
          .then(res => {
            state.testsFromDB = res.data;
            state.testsFromDB = state.testsFromDB.reverse();
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
});

export default store;
